import React from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';
import TrimDetails from '../TrimOverview/TrimDetails';
import themeStyles from './PriceBreakdownModal.styles';
import { selectCurrentVehicleFromVehicles } from '../../core/reducers/vehicles';
import { selectCurrentVehicleModelYear, selectCurrentVehicleTransmissionKey } from '../../core/reducers/currentVehicle';
import { useAppSelector } from '../../core/utils';
const TrimPanelWrapper = themeStyles.apply(Box, 'TrimPanelWrapper');
const TrimPanel = () => {
    var _a, _b;
    const modelYear = useAppSelector(selectCurrentVehicleModelYear);
    const transmissionKey = useAppSelector(selectCurrentVehicleTransmissionKey);
    const vehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const transmissionName = (_b = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmissions) === null || _a === void 0 ? void 0 : _a.find(transmission => transmission.transmissionKey === transmissionKey)) === null || _b === void 0 ? void 0 : _b.transmissionName;
    return (React.createElement(TrimPanelWrapper, { "data-testid": "cy-price-breakdown-trim-panel" },
        React.createElement(Optional, { when: modelYear && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName) && transmissionName },
            React.createElement(TrimDetails, { transmissionName: transmissionName, modelYear: modelYear, modelName: vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelName, trimName: vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName, align: "flex-start", size: "regular" }))));
};
export default TrimPanel;
